// import { useEffect, useState } from 'react';
// import { useDispatch, useSelector } from 'react-redux';
// import { HandCoins, Wallet, PiggyBank, Plus, Pencil } from 'lucide-react';

// import Breadcrumb from '../../../components/Breadcrumb/Breadcrumb';
// import Tabs from '../../../components/Tabs/Tabs';
// import Table, { StatusPill, TABLE_THEME } from '../../../components/Table/Table';

// import usePayrollEntity from '../../../utils/usePayrollEntity';
// import { fmtRs, fmtMoney } from '../../../utils/payrollFormat';
// import { toIsoDate } from '../../../utils/dateFormat';
// import { getEmployeeList } from '../../../action/Employee';
// import { savePayrollEntity } from '../../../action/Payroll';
// import payRollService from '../../../services/PayrollService';
// import AddLoanDialog from '../../../components/Loan/AddLoanDialog';
// import AddLoanInstallmentDialog from '../../../components/Loan/AddLoanInstallmentDialog';
// import { toast } from 'react-toastify';
// import useToast from '../../../utils/useToast';
// import Toast from '../../../components/Toast/Toast';

// const FIELD = `${TABLE_THEME.fieldBase} ${TABLE_THEME.fieldFocus}`;
// const LABEL = TABLE_THEME.fieldLabel;
// const ICON = { size: 15 };

// const TABLE_PROPS = {
//   search: true,
//   searchLabel: 'Search',
//   pageSize: 10,
//   scrollClassName: '',
// };

// const statusColumn = {
//   key: 'status',
//   label: 'Status',
//   align: 'center',
//   render: (r) => <StatusPill label={r.status} />,
// };

// /* ── Loan Management ─────────────────────────────────────────────────────── */
// const LoanManagementTab = () => {
//   const dispatch = useDispatch();

//   const [open, setOpen] = useState(false);
//   const [editingLoan, setEditingLoan] = useState(null);

//   const employees = useSelector((state) => state.employee.list);

//   const { list, loading } = usePayrollEntity('loanManagement');
//   const { list: periods } = usePayrollEntity('payrollPeriods');

//   const { toast, showToast, hideToast } = useToast();

//   useEffect(() => {
//     dispatch(getEmployeeList());
//   }, [dispatch]);

//   const getNextLoanNumber = () => {
//     const maxNumber = list.reduce((max, loan) => {
//       const match = String(loan.loanNo || "").match(/^LN-(\d+)/);

//       if (!match) {
//         return max;
//       }

//       return Math.max(max, Number(match[1]));
//     }, 0);

//     return `LN-${String(maxNumber + 1).padStart(4, "0")}`;
//   }

//   const createLoanInstallments = async (loanId, loan) => {
//     const numberOfInstallments = Number(loan.noOfInstallments || 0);
//     const installmentAmount = Number(loan.installmentAmount || 0);

//     if (!loanId || numberOfInstallments <= 0 || installmentAmount <= 0) {
//       return;
//     }

//     for (let installmentNo = 1; installmentNo <= numberOfInstallments; installmentNo++) {
//       await dispatch(
//         savePayrollEntity("loanInstallments", {
//           loanId: Number(loanId),
//           installmentNo,
//           payrollPeriodId: Number(loan.startPeriodId),
//           dueDate: loan.dueDate,
//           installmentAmount,
//           paidAmount: 0,
//           balanceAmount: installmentAmount,
//           status: 1,
//           payrollId: null,
//           remarks: loan.remarks || "",
//         })
//       )
//     }
//   }

//   // const handleSave = async (form) => {
//   //   await dispatch(savePayrollEntity('loanManagement', form, !!editingLoan));
//   //   setOpen(false);
//   //   setEditingLoan(null);
//   // };

//   const handleSave = async (form) => {
//     const isEditing = !!editingLoan;

//     try {
//       const loanData = {
//         ...form,
//         loanNo: isEditing ? form.loanNo : getNextLoanNumber(),
//         isActive: true,
//       };

//       const loanId = await dispatch(savePayrollEntity('loanManagement', loanData, isEditing));

//       // Only automatically create loan installments when creating a new loan
//       if (!isEditing) {
//         await createLoanInstallments(loanId, loanData);
//       }

//       setOpen(false);
//       setEditingLoan(null);

//       showToast(isEditing ? "Load updated successfully." : "Loan and installments created successfully.", 'success');
//     } catch (error) {
//       console.error("Failed to save loan: ", error);

//       showToast(error?.message || "Failed to save loan.", "error");
//     }
//   }

//   return (
//     <>
//       <Table
//         {...TABLE_PROPS}
//         title="Loan Management"
//         loading={loading}
//         rows={list}
//         rowKey="id"
//         searchKeys={['empNo', 'name', 'loanType']}
//         searchPlaceholder="Search loans..."
//         emptyMessage="No loans found"
//         onAdd={{
//           label: 'New Loan',
//           icon: <Plus {...ICON} />,
//           onClick: () => {
//             setEditingLoan(null);
//             setOpen(true);
//           },
//         }}
//         columns={[
//           { key: 'loanNo', label: 'Loan No', className: 'font-semibold text-gray-900' },
//           { key: 'loanDate', label: 'Loan Date', align: 'center', className: 'text-gray-600 tabular-nums', render: (r) => toIsoDate(r.loanDate) },
//           {
//             key: 'name',
//             label: 'Employee',
//             grow: true,
//             className: 'text-gray-700',
//             render: (r) => {
//               const emp = employees.find(
//                 (e) => String(e.HED_EMPLOYEE_ID) === String(r.employeeId)
//               );
//               return emp ? `${emp.HED_REPORT_NAME} (${emp.HED_SERVICE_NO})` : '-';
//             },
//           },
//           { key: 'loanType', label: 'Loan Type', className: 'text-gray-600' },
//           { key: 'amount', label: 'Loan Amount (Rs)', align: 'right', className: 'font-semibold text-gray-900', render: (r) => fmtMoney(r.amount) },
//           { key: 'installments', label: 'Installments', align: 'right', className: 'text-gray-600' },
//           { key: 'balance', label: 'Balance (Rs)', align: 'right', className: 'text-gray-700', render: (r) => fmtMoney(r.balance) },
//           statusColumn,
//           {
//             key: 'edit',
//             label: 'Actions',
//             align: 'center',
//             sortable: false,
//             render: (r) => (
//               <button
//                 type="button"
//                 title="Edit Loan"
//                 onClick={() => {
//                   setEditingLoan(r);
//                   setOpen(true);
//                 }}
//                 className="inline-flex items-center justify-center w-7 h-7 rounded-md text-gray-500
//                   hover:text-primary-700 hover:bg-primary-50 transition-colors"
//               >
//                 <Pencil size={14} />
//               </button>
//             ),
//           },
//         ]}
//       />

//       <AddLoanDialog
//         open={open}
//         onClose={() => {
//           setOpen(false);
//           setEditingLoan(null);
//         }}
//         nextLoanNo={getNextLoanNumber()}
//         onSave={handleSave}
//         employees={employees}
//         payrollPeriods={periods}
//         loading={loading}
//         initialData={editingLoan}
//       />

//       <Toast 
//         message={toast?.message}
//         type={toast?.type}
//         onClose={hideToast}
//       />
//     </>
//   );
// };

// /* ── Loan Installments ───────────────────────────────────────────────────── */
// const LoanInstallmentsTab = () => {
//   const dispatch = useDispatch();

//   const employees = useSelector((state) => state.employee.list);
//   const { list: periods } = usePayrollEntity('payrollPeriods');

//   const [employeeId, setEmployeeId] = useState('');
//   const [loanId, setLoanId] = useState('');
//   const [loans, setLoans] = useState([]);
//   const [installments, setInstallments] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [open, setOpen] = useState(false);

//   // Map the raw API response from GetInstallmentsByLoan
//   const mapLoanInstallment = (item) => ({
//     id: item.HLI_INSTALLMENT_ID,
//     loanId: item.HLI_LOAN_ID,
//     installmentNo: item.HLI_INSTALLMENT_NO,
//     payrollPeriodId: item.HLI_PAYROLL_PERIOD_ID,
//     dueDate: item.HLI_DUE_DATE.split(' ')[0],
//     installmentAmount: item.HLI_INSTALLMENT_AMOUNT,
//     paidAmount: item.HLI_PAID_AMOUNT,
//     balanceAmount: item.HLI_BALANCE_AMOUNT,
//     status: item.HLI_STATUS === '1' ? 'Active' : 'Inactive',
//     payrollId: item.HLI_PAYROLL_ID,
//     createdBy: item.HLI_CREATED_BY,
//     createdDate: item.HLI_CREATED_DATE,
//     updatedBy: item.HLI_UPDATED_BY,
//     updatedDate: item.HLI_UPDATED_DATE,
//     isActive: item.HLI_IS_ACTIVE,
//     remarks: item.HLI_REMARKS,
//   });

//   const getPayrollPeriodName = (periodId) => {
//     const period = periods.find((p) => String(p.id) === String(periodId));
//     return period ? `${period.code} - ${period.name}` : '-';
//   };

//   const loadLoans = async () => {
//     setLoading(true);
//     try {
//       const response = await payRollService.GetLoansByEmployee(employeeId);
//       setLoans(response.data.ResultSet || []);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const loadInstallments = async () => {
//     setLoading(true);
//     try {
//       const response = await payRollService.GetLoanInstallments(loanId);
//       const list = (response.data.ResultSet || []).map(mapLoanInstallment);
//       setInstallments(list);
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     dispatch(getEmployeeList());
//   }, [dispatch]);

//   useEffect(() => {
//     if (!employeeId) {
//       setLoans([]);
//       setLoanId('');
//       return;
//     }
//     loadLoans();
//   }, [employeeId]);

//   useEffect(() => {
//     if (!loanId) {
//       setInstallments([]);
//       return;
//     }
//     loadInstallments();
//   }, [loanId]);

//   const handleSave = async (form) => {
//     await dispatch(savePayrollEntity('loanInstallments', form));
//     setOpen(false);
//     loadInstallments();
//   };

//   return (
//     <>
//       <Table
//         {...TABLE_PROPS}
//         search={false}
//         title="Loan Installments"
//         loading={loading}
//         rows={installments}
//         rowKey="id"
//         emptyMessage={
//           !employeeId
//             ? 'Select an employee to view installments.'
//             : !loanId
//             ? 'Select a loan to view installments.'
//             : 'No installments found'
//         }
//         // onAdd={{
//         //   label: 'New Installment',
//         //   icon: <Plus {...ICON} />,
//         //   onClick: () => {
//         //     if (!loanId) return;
//         //     setOpen(true);
//         //   },
//         // }}
//         toolbarExtra={
//           <div className="flex flex-wrap items-end gap-3">
//             <div className="w-[300px] max-w-full">
//               <span className={LABEL}>Employee</span>
//               <select
//                 value={employeeId}
//                 onChange={(e) => {
//                   setEmployeeId(e.target.value);
//                   setLoanId('');
//                 }}
//                 className={`${FIELD} w-full`}
//               >
//                 <option value="">Select Employee</option>
//                 {employees.map((emp) => (
//                   <option key={emp.HED_EMPLOYEE_ID} value={emp.HED_EMPLOYEE_ID}>
//                     {emp.HED_SERVICE_NO} - {emp.HED_REPORT_NAME}
//                   </option>
//                 ))}
//               </select>
//             </div>

//             <div className="w-[300px] max-w-full">
//               <span className={LABEL}>Loan</span>
//               <select
//                 value={loanId}
//                 disabled={!employeeId || loading}
//                 onChange={(e) => setLoanId(e.target.value)}
//                 className={`${FIELD} w-full disabled:bg-gray-50 disabled:text-gray-400 disabled:cursor-not-allowed`}
//               >
//                 <option value="">
//                   {!employeeId
//                     ? 'Select Employee First'
//                     : loading
//                     ? 'Loading Loans...'
//                     : loans.length === 0
//                     ? 'No Loans Found'
//                     : 'Select Loan'}
//                 </option>
//                 {loans.map((loan) => (
//                   <option key={loan.HLM_LOAN_ID} value={loan.HLM_LOAN_ID}>
//                     {loan.HLM_LOAN_NO} - {loan.HLM_LOAN_TYPE}
//                   </option>
//                 ))}
//               </select>
//             </div>
//           </div>
//         }
//         columns={[
//           { key: 'installmentNo', label: 'Installment', align: 'center', className: 'font-semibold text-gray-900 tabular-nums' },
//           {
//             key: 'payrollPeriodId',
//             label: 'Payroll Period',
//             grow: true,
//             className: 'text-gray-700',
//             render: (r) => getPayrollPeriodName(r.payrollPeriodId),
//           },
//           { key: 'installmentAmount', label: 'Installment Amount (Rs)', align: 'right', className: 'font-semibold text-gray-900', render: (r) => fmtMoney(r.installmentAmount) },
//           { key: 'paidAmount', label: 'Paid Amount (Rs)', align: 'right', className: 'text-gray-600', render: (r) => fmtMoney(r.paidAmount) },
//           { key: 'balanceAmount', label: 'Balance Amount (Rs)', align: 'right', className: 'text-gray-700', render: (r) => fmtMoney(r.balanceAmount) },
//           { key: 'dueDate', label: 'Due Date', align: 'center', className: 'text-gray-600 tabular-nums', render: (r) => toIsoDate(r.dueDate) },
//           statusColumn,
//         ]}
//       />

//       <AddLoanInstallmentDialog
//         open={open}
//         onClose={() => setOpen(false)}
//         onSave={handleSave}
//         payrollPeriods={periods}
//         loan={loans.find((l) => String(l.HLM_LOAN_ID) === String(loanId))}
//         existingInstallments={installments}
//       />
//     </>
//   );
// };

// /* ── Salary Advances ─────────────────────────────────────────────────────── */
// const SalaryAdvancesTab = () => {
//   const { list, loading } = usePayrollEntity('salaryAdvances');
//   return (
//     <Table
//       {...TABLE_PROPS}
//       title="Salary Advances"
//       loading={loading}
//       rows={list}
//       rowKey="id"
//       searchKeys={['empNo', 'name']}
//       searchPlaceholder="Search salary advances..."
//       emptyMessage="No salary advances found"
//       onAdd={{ label: 'New Advance', icon: <Plus {...ICON} /> }}
//       columns={[
//         { key: 'name', label: 'Employee', grow: true, className: 'font-semibold text-gray-900', render: (r) => `${r.name} (${r.empNo})` },
//         { key: 'amount', label: 'Amount (Rs)', align: 'right', className: 'font-semibold text-gray-900', render: (r) => fmtMoney(r.amount) },
//         { key: 'requestDate', label: 'Request Date', align: 'center', className: 'text-gray-600 tabular-nums', render: (r) => toIsoDate(r.requestDate) },
//         { key: 'recoveryMonth', label: 'Recovery Month', align: 'center', className: 'text-gray-600' },
//         statusColumn,
//       ]}
//     />
//   );
// };

// /* ── Page ────────────────────────────────────────────────────────────────── */
// const LoansAdvances = () => {
//   const tabs = [
//     { key: 'loans', label: 'Loan Management', icon: <HandCoins {...ICON} />, content: <LoanManagementTab /> },
//     { key: 'installments', label: 'Loan Installments', icon: <Wallet {...ICON} />, content: <LoanInstallmentsTab /> },
//     // { key: 'advances', label: 'Salary Advances', icon: <PiggyBank {...ICON} />, content: <SalaryAdvancesTab /> },
//   ];

//   return (
//     <div className="p-6 space-y-4">
//       <Breadcrumb
//         trail={['Payroll', 'Loans & Advances']}
//         title="Loans & Advances"
//         subtitle="Manage staff loans, installment schedules and salary advances."
//       />
//       <Tabs tabs={tabs} defaultTab="loans" />
//     </div>
//   );
// };

// export default LoansAdvances;




import { useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { HandCoins, Wallet, PiggyBank, Plus, Pencil, Eye, Upload } from 'lucide-react';
import SearchableSelect from '../../../components/common/SearchableSelect';

import Breadcrumb from '../../../components/Breadcrumb/Breadcrumb';
import Tabs from '../../../components/Tabs/Tabs';
import Table, { StatusPill, TABLE_THEME } from '../../../components/Table/Table';

import usePayrollEntity from '../../../utils/usePayrollEntity';
import { fmtRs, fmtMoney } from '../../../utils/payrollFormat';
import { toIsoDate } from '../../../utils/dateFormat';
import { fetchAllEmployees } from '../../../store/slices/employeeSlice';
import { fetchLoanList, savePayrollEntity } from '../../../store/slices/payrollSlice';
import payRollService from '../../../services/PayrollService';
import AddLoanDialog from '../../../components/Loan/AddLoanDialog';
import AddLoanInstallmentDialog from '../../../components/Loan/AddLoanInstallmentDialog';
import { toast } from 'react-toastify';
import useToast from '../../../utils/useToast';
import Toast from '../../../components/Toast/Toast';
import { useConfirm } from '../../../utils/ConfirmContext';
import { ApproveLoanDialog } from '../../../components/Loan/ApproveLoanDialog';
import { getLoggedInServiceNo } from '../../../utils/masterDataUtils';
import loanDetailsService from '../../../services/LoanDetailsService';
import LoanTypesDialog from '../../../components/Loan/LoanTypesDialog';
import { fetchAllLoanTypes } from '../../../store/slices/loanDetailsSlice';
import ImportLoansModal from '../../../components/Loan/ImportLoansModal';

const FIELD = `${TABLE_THEME.fieldBase} ${TABLE_THEME.fieldFocus}`;
const LABEL = TABLE_THEME.fieldLabel;
const ICON = { size: 15 };

const TABLE_PROPS = {
  search: true,
  searchLabel: 'Search',
  pageSize: 10,
  scrollClassName: '',
};

const statusColumn = {
  key: 'status',
  label: 'Status',
  align: 'center',
  render: (r) => <StatusPill label={r.status} />,
};

/* ── Loan Types ─────────────────────────────────────────────────────── */
const LoanTypesTab = () => {
  const dispatch = useDispatch();
  const { loanTypes = [], loadingLoanTypes } = useSelector((state) => state.loanDetails || {});
  const { toast, showToast, hideToast } = useToast();

  const [dialogOpen, setDialogOpen] = useState(false);
  const [dialogMode, setDialogMode] = useState("add");
  const [selectedType, setSelectedType] = useState(null);
  const [categoryFilter, setCategoryFilter] = useState("All");

  useEffect(() => {
    dispatch(fetchAllLoanTypes());
  }, [dispatch]);

  const filteredLoanTypes = useMemo(() => {
    if (categoryFilter === "All") return loanTypes;
    return loanTypes.filter((item) => item.categoryCode === categoryFilter);
  }, [loanTypes, categoryFilter]);

  return (
    <>
      <Table
        {...TABLE_PROPS}
        title="Loan Types"
        loading={loadingLoanTypes}
        rows={filteredLoanTypes}
        rowKey="id"
        searchKeys={["typeName", "categoryName", "description"]}
        searchPlaceholder="Search loan types..."
        emptyMessage="No loan types found"
        defaultSort={{ key: "typeName", dir: "asc" }}
        onAdd={{
          label: "New Loan Type",
          icon: <Plus {...ICON} />,
          onClick: () => {
            setSelectedType(null);
            setDialogMode("add");
            setDialogOpen(true);
          },
        }}
        toolbarExtra={
          <div className="flex flex-wrap items-end gap-3">
            <div className="w-[180px] max-w-full">
              <span className={LABEL}>Category</span>
              <select
                value={categoryFilter}
                onChange={(e) => setCategoryFilter(e.target.value)}
                className={`${FIELD} w-full`}
              >
                <option value="All">All Categories</option>
                <option value="M">Loan</option>
                <option value="O">Other Loan</option>
              </select>
            </div>
          </div>
        }
        columns={[
          {
            key: "typeName",
            label: "Type Name",
            className: "font-semibold text-gray-900",
          },
          {
            key: "categoryName",
            label: "Category",
            align: "center",
            render: (r) => (
              <span className="rounded-md bg-surface-100 px-2 py-0.5 text-xs font-medium text-gray-600">
                {r.categoryName}
              </span>
            ),
          },
          {
            key: "description",
            label: "Description",
            grow: true,
            className: "text-gray-600",
            render: (r) => r.description || "-",
          },
          statusColumn,
          {
            key: "actions",
            label: "Actions",
            align: "center",
            render: (r) => (
              <div className="flex items-center justify-center gap-1">
                <button
                  type="button"
                  title="View"
                  onClick={() => {
                    setSelectedType(r);
                    setDialogMode("view");
                    setDialogOpen(true);
                  }}
                  className="inline-flex items-center justify-center w-7 h-7 rounded-md text-gray-500 hover:text-primary-700 hover:bg-primary-50"
                >
                  <Eye size={14} />
                </button>
                <button
                  type="button"
                  title="Edit"
                  onClick={() => {
                    setSelectedType(r);
                    setDialogMode("edit");
                    setDialogOpen(true);
                  }}
                  className="inline-flex items-center justify-center w-7 h-7 rounded-md text-gray-500 hover:text-primary-700 hover:bg-primary-50"
                >
                  <Pencil size={14} />
                </button>
              </div>
            ),
          },
        ]}
      />

      <LoanTypesDialog
        open={dialogOpen}
        mode={dialogMode}
        loanType={selectedType}
        onClose={() => {
          setDialogOpen(false);
          setSelectedType(null);
        }}
        onSuccess={(msg) => {
          showToast(msg, "success");
        }}
        onError={(msg) => {
          showToast(msg, "error");
        }}
      />

      <Toast message={toast?.message} type={toast?.type} onClose={hideToast} />
    </>
  );
};

/* ── Loan Management ─────────────────────────────────────────────────────── */
const LoanManagementTab = () => {
  const dispatch = useDispatch();

  const [open, setOpen] = useState(false);
  const [editingLoan, setEditingLoan] = useState(null);
  const [loanStatus, setLoanStatus] = useState("approved");
  const [dialogMode, setDialogMode] = useState("add");
  const [nextLoanNo, setNextLoanNo] = useState("");
  const [importModalOpen, setImportModalOpen] = useState(false);

  const employees = useSelector((state) => state.employees.employees);

  const loanEntity = useSelector((state) => state.payroll.entities.loanManagement || {
    list: [],
    loading: false,
  })

  const { loanTypes = [] } = useSelector((state) => state.loanDetails || {});
  const { list, loading } = loanEntity;

  const { list: periods } = usePayrollEntity('payrollPeriods');

  const { toast, showToast, hideToast } = useToast();

  useEffect(() => {
    dispatch(fetchAllEmployees());
  }, [dispatch]);

  useEffect(() => {
    dispatch(fetchLoanList(loanStatus === "approved" ? 1 : 0));
  }, [dispatch, loanStatus]);

  useEffect(() => {
    dispatch(fetchAllLoanTypes());
  }, [dispatch]);

  // const getNextLoanNumber = () => {
  //   const maxNumber = list.reduce((max, loan) => {
  //     const match = String(loan.loanNo || "").match(/^LN-(\d+)/);

  //     if (!match) {
  //       return max;
  //     }

  //     return Math.max(max, Number(match[1]));
  //   }, 0);

  //   return `LN-${String(maxNumber + 1).padStart(4, "0")}`;
  // }

  const getNextLoanNumber = async () => {
    try {
      const [activeRes, inactiveRes] = await Promise.all([
        payRollService.GetLoanList(1),
        payRollService.GetLoanList(0),
      ]);

      const allLoans = [
        ...(activeRes?.data?.ResultSet || []),
        ...(inactiveRes?.data?.ResultSet || []),
      ];

      const maxNumber = allLoans.reduce((max, loan) => {
        const loanNo = loan.HLM_LOAN_NO || loan.loanNo || "";
        const match = String(loanNo).match(/^LN-(\d+)/i);

        if (!match) return max;
        return Math.max(max, parseInt(match[1], 10));
      }, 0);

      return `LN-${String(maxNumber + 1).padStart(4, "0")}`;
    } catch (err) {
      console.error("Failed to calculate next loan number across all loans:", err);
      // Fallback to table list if API call fails
      const maxNumber = list.reduce((max, loan) => {
        const match = String(loan.loanNo || "").match(/^LN-(\d+)/i);
        return match ? Math.max(max, parseInt(match[1], 10)) : max;
      }, 0);
      return `LN-${String(maxNumber + 1).padStart(4, "0")}`;
    }
  };

  const addMonths = (date, months) => {
    const originalDay = date.getDate();

    const result = new Date(date);
    result.setDate(1);
    result.setMonth(result.getMonth() + months);

    const lastDayOfMonth = new Date(
      result.getFullYear(),
      result.getMonth() + 1,
      0
    ).getDate();

    result.setDate(Math.min(originalDay, lastDayOfMonth));

    return result;
  }

  const formatDate = (date) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');

    return `${year}-${month}-${day}`
  }

  const createLoanInstallments = async (loanId, loan) => {
    const numberOfInstallments = Number(loan.noOfInstallments || 0);
    const installmentAmount = Number(loan.installmentAmount || 0);

    if (!loanId || numberOfInstallments <= 0 || installmentAmount <= 0) {
      return;
    }

    const firstDueDate = new Date(loan.dueDate);

    for (let installmentNo = 1; installmentNo <= numberOfInstallments; installmentNo++) {
      const installmentDueDate = formatDate(addMonths(firstDueDate, installmentNo - 1));

      await dispatch(
        savePayrollEntity("loanInstallments", {
          loanId: Number(loanId),
          installmentNo,
          payrollPeriodId: Number(loan.startPeriodId),
          dueDate: installmentDueDate,
          installmentAmount,
          paidAmount: 0,
          balanceAmount: installmentAmount,
          status: 1,
          payrollId: null,
          remarks: loan.remarks || "",
        })
      )
    }
  }

  // const handleSave = async (form) => {
  //   await dispatch(savePayrollEntity('loanManagement', form, !!editingLoan));
  //   setOpen(false);
  //   setEditingLoan(null);
  // };

  const handleSave = async (form) => {
    const isEditing = !!editingLoan;
    const isOtherLoan = form.loanCategory === "O";

    try {
      const resolvedLoanNo = isEditing 
        ? form.loanNo 
        : (form.loanNo || (await getNextLoanNumber()));

      const loanData = {
        ...form,
        loanNo: resolvedLoanNo,
        isActive: isEditing 
          ? (form.isActive ?? editingLoan.isActive ?? true) 
          : (isOtherLoan ? true : false),
        status: isOtherLoan ? "P" : (form.status || "P"),
      };

      const loanId = await dispatch(savePayrollEntity('loanManagement', loanData, isEditing));

      // Only automatically create loan installments when creating a new loan
      if (!isEditing) {
        await createLoanInstallments(loanId, loanData);
      }

      // Save any staged sureties on a new loan
      if (!isEditing && form.pendingSureties?.length > 0) {
        for (const s of form.pendingSureties) {
          await loanDetailsService.AddSurety({
            loanNo: loanData.loanNo,
            employeeId: s.employeeId,
            year: new Date().getFullYear(),
            type: s.type,
            remarks: s.remarks,
            date: s.date,
          });
        }
      }

      // Upload all staged documents
      if (form.pendingDocs?.length > 0) {
        for (const doc of form.pendingDocs) {
          await loanDetailsService.UploadLoanDocs(
            loanData.loanNo,
            doc.docType,
            doc.file
          )
        }
      }

      setOpen(false);
      setEditingLoan(null);

      showToast(
        isEditing 
          ? "Load updated successfully." 
          : isOtherLoan
            ? "Other loan created and activated successfully."
            : "Loan, installments and attachments created successfully.", 
        'success'
      );
      dispatch(fetchLoanList(loanStatus === "approved" ? 1 : 0))
    } catch (error) {
      console.error("Failed to save loan: ", error);
      showToast(error?.message || "Failed to save loan.", "error");
    }
  }

  return (
    <>
      <Table
        {...TABLE_PROPS}
        title="Loan Management"
        loading={loading}
        rows={list}
        rowKey="id"
        searchKeys={['empNo', 'name', 'loanType', 'loanNo']}
        searchPlaceholder="Search loans..."
        emptyMessage="No loans found"
        defaultSort={{ key: 'loanNo', dir: 'desc' }}
        onAdd={{
          label: 'New Loan',
          icon: <Plus {...ICON} />,
          onClick: async () => {
            const nextNo = await getNextLoanNumber();
            setNextLoanNo(nextNo);
            setEditingLoan(null);
            setDialogMode("add");
            setOpen(true);
          },
        }}
        toolbarExtra={
          <div className='flex flex-wrap items-end gap-3'>
            <div className='w-[220px] max-w-full'>
              <span className={LABEL}>Loan Status</span>

              <select
                value={loanStatus}
                onChange={(e) => setLoanStatus(e.target.value)}
                className={`${FIELD} w-full`}
              >  
                <option value="approved">Approved</option>
                <option value="notApproved">Not Approved</option>
              </select>
            </div>

            <button
              type="button"
              onClick={() => setImportModalOpen(true)}
              className="flex items-center justify-center gap-2 h-9 px-4 rounded-md bg-white border border-gray-300 text-[13px] font-medium text-gray-700 hover:bg-gray-50 focus:ring-1 focus:ring-primary-500 transition-colors shadow-sm"
            >
              <Upload size={14} className="text-gray-500" />
              Import
            </button>
          </div>
        }
        columns={[
          { key: 'loanNo', label: 'Loan No', className: 'font-semibold text-gray-900' },
          // { key: 'loanDate', label: 'Loan Date', align: 'center', className: 'text-gray-600 tabular-nums', render: (r) => toIsoDate(r.loanDate) },
          {
            key: 'name',
            label: 'Employee',
            grow: true,
            className: 'text-gray-700',
            render: (r) => {
              const emp = employees.find(
                (e) => String(e.HED_EMPLOYEE_ID) === String(r.employeeId)
              );
              return emp ? `${emp.HED_REPORT_NAME} (${emp.HED_SERVICE_NO})` : '-';
            },
          },
          { key: 'loanType', label: 'Loan Type', className: 'text-gray-600' },
          { key: 'amount', label: 'Loan Amount (Rs)', align: 'right', className: 'font-semibold text-gray-900', render: (r) => fmtMoney(r.amount) },
          { key: 'installments', label: 'Installments', align: 'right', className: 'text-gray-600' },
          { key: 'balance', label: 'Balance (Rs)', align: 'right', className: 'text-gray-700', render: (r) => fmtMoney(r.balance) },
          { key: 'loanDate', label: 'Processed Date', align: 'center', className: 'text-gray-600 tabular-nums', render: (r) => r.loanDate ? toIsoDate(r.loanDate) : '-' },
          statusColumn,
          {
            key: 'actions',
            label: 'Actions',
            align: 'center',
            sortable: false,
            render: (r) => {
              const processedDate = r.loanDate ? toIsoDate(r.loanDate) : null;
              const isPastProceessedDate = Boolean(processedDate && toIsoDate(new Date()) > processedDate);

              return (
                <div className="flex items-center justify-center gap-1">
                  {/* View Loan */}
                  <button
                    type="button"
                    title="View Loan Details"
                    onClick={() => {
                      setEditingLoan(r);
                      setDialogMode("view");
                      setOpen(true);
                    }}
                    className="inline-flex items-center justify-center w-7 h-7 rounded-md text-gray-500
                      hover:text-primary-700 hover:bg-primary-50 transition-colors"
                  >
                    <Eye size={14} />
                  </button>

                  {/* Edit Loan */}
                  <button
                    type="button"
                    disabled={isPastProceessedDate}
                    title={
                      isPastProceessedDate ? "Cannot edit loan after processed date" : "Edit Loan"
                    }
                    onClick={() => {
                      setEditingLoan(r);
                      setDialogMode("edit");
                      setOpen(true);
                    }}
                    className="inline-flex items-center justify-center w-7 h-7 rounded-md text-gray-500
                      hover:text-primary-700 hover:bg-primary-50 transition-colors
                      disabled:opacity-30 disabled:cursor-not-allowed disabled:hover:bg-transparent disabled:hover:text-gray-500"
                  >
                    <Pencil size={14} />
                  </button>
                </div>
              );
            },
          },
        ]}
      />

      <AddLoanDialog
        open={open}
        mode={dialogMode}
        onClose={() => {
          setOpen(false);
          setEditingLoan(null);
        }}
        nextLoanNo={nextLoanNo}
        onSave={handleSave}
        employees={employees}
        payrollPeriods={periods}
        loading={loading}
        initialData={editingLoan}
      />

      <ImportLoansModal 
        open={importModalOpen}
        onClose={() => setImportModalOpen(false)}
        employees={employees}
        loanTypes={loanTypes}
        periods={periods}
        getNextLoanNumber={getNextLoanNumber}
        onSuccess={(count) => {
          setImportModalOpen(false);
          showToast(`Successfully imported ${count} loan(s).`, "success");
          dispatch(fetchLoanList(loanStatus === "approved" ? 1 : 0));
        }}
      />

      <Toast 
        message={toast?.message}
        type={toast?.type}
        onClose={hideToast}
      />
    </>
  );
};

/* ── Loan Installments ───────────────────────────────────────────────────── */
const LoanInstallmentsTab = () => {
  const dispatch = useDispatch();

  const employees = useSelector((state) => state.employees.employees);
  const { list: periods } = usePayrollEntity('payrollPeriods');

  const [employeeId, setEmployeeId] = useState('');
  const [loanId, setLoanId] = useState('');
  const [loans, setLoans] = useState([]);
  const [installments, setInstallments] = useState([]);
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);

  // Map the raw API response from GetInstallmentsByLoan
  const mapLoanInstallment = (item) => ({
    id: item.HLI_INSTALLMENT_ID,
    loanId: item.HLI_LOAN_ID,
    installmentNo: item.HLI_INSTALLMENT_NO,
    payrollPeriodId: item.HLI_PAYROLL_PERIOD_ID,
    dueDate: item.HLI_DUE_DATE.split(' ')[0],
    installmentAmount: item.HLI_INSTALLMENT_AMOUNT,
    paidAmount: item.HLI_PAID_AMOUNT,
    balanceAmount: item.HLI_BALANCE_AMOUNT,
    status: item.HLI_STATUS === '1' ? 'Active' : 'Inactive',
    payrollId: item.HLI_PAYROLL_ID,
    createdBy: item.HLI_CREATED_BY,
    createdDate: item.HLI_CREATED_DATE,
    updatedBy: item.HLI_UPDATED_BY,
    updatedDate: item.HLI_UPDATED_DATE,
    isActive: item.HLI_IS_ACTIVE,
    remarks: item.HLI_REMARKS,
  });

  const getPayrollPeriodName = (periodId) => {
    const period = periods.find((p) => String(p.id) === String(periodId));
    return period ? `${period.code} - ${period.name}` : '-';
  };

  const loadLoans = async () => {
    setLoading(true);
    try {
      const response = await payRollService.GetLoansByEmployee(employeeId);
      setLoans(response.data.ResultSet || []);
    } finally {
      setLoading(false);
    }
  };

  const loadInstallments = async () => {
    setLoading(true);
    try {
      const response = await payRollService.GetLoanInstallments(loanId);
      const list = (response.data.ResultSet || []).map(mapLoanInstallment);
      setInstallments(list);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    dispatch(fetchAllEmployees());
  }, [dispatch]);

  useEffect(() => {
    if (!employeeId) {
      setLoans([]);
      setLoanId('');
      return;
    }
    loadLoans();
  }, [employeeId]);

  useEffect(() => {
    if (!loanId) {
      setInstallments([]);
      return;
    }
    loadInstallments();
  }, [loanId]);

  const handleSave = async (form) => {
    await dispatch(savePayrollEntity('loanInstallments', form));
    setOpen(false);
    loadInstallments();
  };

  const resolveInstallmentName = (dueDate) => {
    const [year, month, day] = dueDate.split("-");

    const months = [
      "January", "February", "March", "April", "May", "June",
      "July", "August", "September", "October", "November", "December"
    ];

    const monthName = months[parseInt(month, 10) - 1] ?? "-";

    return `${year} ${monthName}`
  }

  return (
    <>
      <Table
        {...TABLE_PROPS}
        search={false}
        title="Loan Installments"
        loading={loading}
        rows={installments}
        rowKey="id"
        emptyMessage={
          !employeeId
            ? 'Select an employee to view installments.'
            : !loanId
            ? 'Select a loan to view installments.'
            : 'No installments found'
        }
        // onAdd={{
        //   label: 'New Installment',
        //   icon: <Plus {...ICON} />,
        //   onClick: () => {
        //     if (!loanId) return;
        //     setOpen(true);
        //   },
        // }}
        toolbarExtra={
          <div className="flex flex-wrap items-end gap-3">
            <div className="w-[300px] max-w-full">
              <span className={LABEL}>Employee</span>
              {/* OLD native select (kept for reference):
              <select
                value={employeeId}
                onChange={(e) => {
                  setEmployeeId(e.target.value);
                  setLoanId('');
                }}
                className={`${FIELD} w-full`}
              >
                <option value="">Select Employee</option>
                {employees.map((emp) => (
                  <option key={emp.HED_EMPLOYEE_ID} value={emp.HED_EMPLOYEE_ID}>
                    {emp.HED_SERVICE_NO} - {emp.HED_REPORT_NAME}
                  </option>
                ))}
              </select>
              */}
              {/* Search matches service no or name. Changing it clears the loan. */}
              <SearchableSelect
                value={employeeId}
                onChange={(v) => {
                  setEmployeeId(v);
                  setLoanId('');
                }}
                options={employees.map((emp) => ({
                  value: String(emp.HED_EMPLOYEE_ID),
                  label: `${emp.HED_SERVICE_NO ?? ''} - ${emp.HED_REPORT_NAME ?? ''}`,
                }))}
                emptyOption={{ value: '', label: 'Select Employee' }}
                placeholder="Select Employee"
                searchPlaceholder="Search by service no or name..."
                className={`${FIELD} w-full`}
              />
            </div>

            <div className="w-[300px] max-w-full">
              <span className={LABEL}>Loan</span>
              {(() => {
                const loanPlaceholder = !employeeId
                  ? 'Select Employee First'
                  : loans.length === 0
                  ? 'No Loans Found'
                  : 'Select Loan';
                return (
                  <SearchableSelect
                    value={loanId}
                    disabled={!employeeId}
                    loading={!!employeeId && loading}
                    loadingLabel="Loading Loans..."
                    onChange={setLoanId}
                    options={loans.map((loan) => ({
                      value: loan.HLM_LOAN_ID,
                      label: `${loan.HLM_LOAN_NO} - ${loan.HLM_LOAN_TYPE}`,
                    }))}
                    emptyOption={{ value: '', label: loanPlaceholder }}
                    placeholder={loanPlaceholder}
                    searchPlaceholder="Search loan no or type..."
                    className={`${FIELD} w-full disabled:bg-gray-50 disabled:text-gray-400 disabled:cursor-not-allowed`}
                  />
                );
              })()}
            </div>
          </div>
        }
        columns={[
          { key: 'installmentNo', label: 'Installment', align: 'center', className: 'font-semibold text-gray-900 tabular-nums' },
          {
            key: 'payrollPeriodId',
            label: 'Payroll Period',
            grow: true,
            className: 'text-gray-700',
            // render: (r) => getPayrollPeriodName(r.payrollPeriodId),
            render: (r) => resolveInstallmentName(toIsoDate(r.dueDate)),
          },
          { key: 'installmentAmount', label: 'Installment Amount (Rs)', align: 'right', className: 'font-semibold text-gray-900', render: (r) => fmtMoney(r.installmentAmount) },
          { key: 'paidAmount', label: 'Paid Amount (Rs)', align: 'right', className: 'text-gray-600', render: (r) => fmtMoney(r.paidAmount) },
          { key: 'balanceAmount', label: 'Balance Amount (Rs)', align: 'right', className: 'text-gray-700', render: (r) => fmtMoney(r.balanceAmount) },
          { key: 'dueDate', label: 'Due Date', align: 'center', className: 'text-gray-600 tabular-nums', render: (r) => toIsoDate(r.dueDate) },
          statusColumn,
        ]}
      />

      <AddLoanInstallmentDialog
        open={open}
        onClose={() => setOpen(false)}
        onSave={handleSave}
        payrollPeriods={periods}
        loan={loans.find((l) => String(l.HLM_LOAN_ID) === String(loanId))}
        existingInstallments={installments}
      />
    </>
  );
};

const LoanApprovalTab = () => {
  const dispatch = useDispatch();

  const employees = useSelector((state) => state.employees.employees);

  const loanEntity = useSelector(
    (state) => state.payroll.entities.loanManagement || {
      list: [],
      loading: false,
    }
  );

  const { list, loading } = loanEntity;

  const { toast, showToast, hideToast } = useToast();

  const [selectedLoan, setSelectedLoan] = useState(null);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [viewingLoan, setViewingLoan] = useState(null);
  const [viewDialogOpen, setViewDialogOpen] = useState(false);
  const { list: periods } = usePayrollEntity('payrollPeriods');

  useEffect(() => {
    dispatch(fetchAllEmployees());
  }, [dispatch]);

  useEffect(() => {
    dispatch(fetchLoanList(0));
  }, [dispatch]);

  const handleOpenApproveModal = (loan) => {
    setSelectedLoan(loan);
    setDialogOpen(true);
  }

  const handleConfirmApproval = async (processedDate) => {
    if (!processedDate || !selectedLoan) return;

    setSubmitting(true);
    try {
      const today = new Date().toISOString().split("T")[0];
      const approvedBy = getLoggedInServiceNo() || "ADMIN";

      await dispatch(savePayrollEntity(
        'loanManagement',
        {
          ...selectedLoan,
          loanDate: processedDate,
          approvedDate: today,
          approvedBy: approvedBy,
          isActive: true,
        },
        true
      ));

      showToast("Loan approved successfully.", "success");
      setDialogOpen(false);
      setSelectedLoan(null);

      dispatch(fetchLoanList(0));
    } catch (error) {
      console.error("Failed to approve loan: ", error);
      showToast(error?.message || "Failed to approve loan.", "error");
    } finally {
      setSubmitting(false);
    }
  }

  // const handleApprove = async (loan) => {
  //   const confirmed = await confirm({
  //     title: `Approve this loan?`,
  //     message: `Are you sure you want to approve loan ${loan.loanNo}?`,
  //     confirmLabel: "Approve",
  //     cancelLabel: "Cancel",
  // });

  //   if (!confirmed) {
  //     return;
  //   }

  //   try {
  //     const approvedDate = new Date().toISOString().split("T")[0];

  //     await dispatch(
  //       savePayrollEntity(
  //         'loanManagement',
  //         {
  //           ...loan,
  //           isActive: true,
  //           approvedDate,
  //         },
  //         true
  //       )
  //     );

  //     showToast("Loan approved successfully.", "success");

  //     // Refresh pending loans
  //     dispatch(fetchLoanList(0));
  //   } catch (error) {
  //     console.error("Failed to approve loan:", error);

  //     showToast(
  //       error?.message || "Failed to approve loan.",
  //       "error"
  //     );
  //   }
  // };

  return (
    <>
      <Table
        {...TABLE_PROPS}
        title="Loan Approval"
        loading={loading}
        rows={list}
        rowKey="id"
        searchKeys={['empNo', 'name', 'loanType']}
        searchPlaceholder="Search loans..."
        emptyMessage="No loans pending approval"
        defaultSort={{ key: 'loanNo', dir: 'desc' }}
        columns={[
          {
            key: 'loanNo',
            label: 'Loan No',
            className: 'font-semibold text-gray-900',
          },
          // {
          //   key: 'loanDate',
          //   label: 'Loan Date',
          //   align: 'center',
          //   className: 'text-gray-600 tabular-nums',
          //   render: (r) => toIsoDate(r.loanDate),
          // },
          {
            key: 'name',
            label: 'Employee',
            grow: true,
            className: 'text-gray-700',
            render: (r) => {
              const emp = employees.find(
                (e) =>
                  String(e.HED_EMPLOYEE_ID) ===
                  String(r.employeeId)
              );

              return emp
                ? `${emp.HED_REPORT_NAME} (${emp.HED_SERVICE_NO})`
                : '-';
            },
          },
          {
            key: 'loanType',
            label: 'Loan Type',
            className: 'text-gray-600',
          },
          {
            key: 'amount',
            label: 'Loan Amount (Rs)',
            align: 'right',
            className: 'font-semibold text-gray-900',
            render: (r) => fmtMoney(r.amount),
          },
          {
            key: 'installments',
            label: 'Installments',
            align: 'right',
            className: 'text-gray-600',
          },
          {
            key: 'balance',
            label: 'Balance (Rs)',
            align: 'right',
            className: 'text-gray-700',
            render: (r) => fmtMoney(r.balance),
          },
          { key: 'loanDate', label: 'Processed Date', align: 'center', className: 'text-gray-600 tabular-nums', render: (r) => r.approvedDate ? toIsoDate(r.approvedDate) : '-' },
          statusColumn,
          {
            key: 'approve',
            label: 'Actions',
            align: 'center',
            sortable: false,
            render: (r) => (
              <div className="flex items-center justify-center gap-2">
                <button
                  type="button"
                  title="View Loan Details"
                  onClick={() => {
                    setViewingLoan(r);
                    setViewDialogOpen(true);
                  }}
                  className="inline-flex items-center justify-center w-7 h-7 rounded-md text-gray-500
                    hover:text-primary-700 hover:bg-primary-50 transition-colors"
                >
                  <Eye size={15} />
                </button>

                <button
                  type="button"
                  onClick={() => handleOpenApproveModal(r)}
                  className="inline-flex items-center justify-center px-3 py-1.5 rounded-md
                    text-xs font-medium text-white bg-primary-600
                    hover:bg-primary-700 transition-colors"
                >
                  Approve Loan
                </button>
              </div>
            ),
          },
        ]}
      />

      <ApproveLoanDialog
        open={dialogOpen}
        loan={selectedLoan}
        loading={submitting}
        onClose={() => {
          setDialogOpen(false);
          setSelectedLoan(null);
        }}
        onConfirm={handleConfirmApproval}
      />

      <AddLoanDialog
        open={viewDialogOpen}
        mode="view"
        onClose={() => {
          setViewDialogOpen(false);
          setViewingLoan(null);
        }}
        employees={employees}
        payrollPeriods={periods}
        initialData={viewingLoan}
      />

      <Toast
        message={toast?.message}
        type={toast?.type}
        onClose={hideToast}
      />
    </>
  );
};

/* ── Salary Advances ─────────────────────────────────────────────────────── */
const SalaryAdvancesTab = () => {
  const { list, loading } = usePayrollEntity('salaryAdvances');
  return (
    <Table
      {...TABLE_PROPS}
      title="Salary Advances"
      loading={loading}
      rows={list}
      rowKey="id"
      searchKeys={['empNo', 'name']}
      searchPlaceholder="Search salary advances..."
      emptyMessage="No salary advances found"
      onAdd={{ label: 'New Advance', icon: <Plus {...ICON} /> }}
      columns={[
        { key: 'name', label: 'Employee', grow: true, className: 'font-semibold text-gray-900', render: (r) => `${r.name} (${r.empNo})` },
        { key: 'amount', label: 'Amount (Rs)', align: 'right', className: 'font-semibold text-gray-900', render: (r) => fmtMoney(r.amount) },
        { key: 'requestDate', label: 'Request Date', align: 'center', className: 'text-gray-600 tabular-nums', render: (r) => toIsoDate(r.requestDate) },
        { key: 'recoveryMonth', label: 'Recovery Month', align: 'center', className: 'text-gray-600' },
        statusColumn,
      ]}
    />
  );
};

/* ── Page ────────────────────────────────────────────────────────────────── */
const LoansAdvances = () => {
  const tabs = [
    { key: 'types', label: 'Loan Types', icon: <PiggyBank {...ICON} />, content: <LoanTypesTab /> },
    { key: 'loans', label: 'Loan Management', icon: <HandCoins {...ICON} />, content: <LoanManagementTab /> },
    { key: 'installments', label: 'Loan Installments', icon: <Wallet {...ICON} />, content: <LoanInstallmentsTab /> },
    { key: 'approval', label: 'Loan Approval', icon: <HandCoins {...ICON} />, content: <LoanApprovalTab /> },
    // { key: 'advances', label: 'Salary Advances', icon: <PiggyBank {...ICON} />, content: <SalaryAdvancesTab /> },
  ];

  return (
    <div className="p-6 space-y-4">
      <Breadcrumb
        trail={['Payroll', 'Loans & Advances']}
        title="Loans & Advances"
        subtitle="Manage staff loans, installment schedules and salary advances."
      />
      <Tabs tabs={tabs} defaultTab="types" />
    </div>
  );
};

export default LoansAdvances;